import {
  getPage,
  getDetail,
  getClientPage,
  datevehicleInfoGrouplocalalarmlimitspeedlimit,
  datelocalalarmlimitAndspeedlimit,
} from '@/api/speedlimitareaanalysisregulationserv'

export default {
  state: {
    state_SpeedLimitAreaAnalysisRegulation_GetPageResult: null,
    state_SpeedLimitAreaAnalysisRegulation_GetDetailResult: null,
    state_SpeedLimitAreaAnalysisRegulation_GetClientPageResult: null,
    state_SpeedLimitAreaAnalysisRegulation_DatevehicleInfoGrouplocalalarmlimitspeedlimitResult: null,
    state_SpeedLimitAreaAnalysisRegulation_DatelocalalarmlimitAndspeedlimitResult: null,
  },
  mutations: {
    SET_SPEEDLIMITAREAANALYSISREGULATION_GETPAGE_RESULT: (state, rst) => {
      state.state_SpeedLimitAreaAnalysisRegulation_GetPageResult = rst;
    },
    SET_SPEEDLIMITAREAANALYSISREGULATION_GETDETAIL_RESULT: (state, rst) => {
      state.state_SpeedLimitAreaAnalysisRegulation_GetDetailResult = rst;
    },
    SET_SPEEDLIMITAREAANALYSISREGULATION_GETCLIENTPAGE_RESULT: (state, rst) => {
      state.state_SpeedLimitAreaAnalysisRegulation_GetClientPageResult = rst;
    },
    SET_SPEEDLIMITAREAANALYSISREGULATION_DATEVEHICLEINFOGROUPLOCALALARMLIMITSPEEDLIMIT_RESULT: (state, rst) => {
      state.state_SpeedLimitAreaAnalysisRegulation_DatevehicleInfoGrouplocalalarmlimitspeedlimitResult = rst;
    },
    SET_SPEEDLIMITAREAANALYSISREGULATION_DATELOCALALARMLIMITANDSPEEDLIMIT_RESULT: (state, rst) => {
      state.state_SpeedLimitAreaAnalysisRegulation_DatelocalalarmlimitAndspeedlimitResult = rst;
    },
  },
  actions: {
    SpeedLimitAreaAnalysisRegulationServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SPEEDLIMITAREAANALYSISREGULATION_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SPEEDLIMITAREAANALYSISREGULATION_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    SpeedLimitAreaAnalysisRegulationServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SPEEDLIMITAREAANALYSISREGULATION_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SPEEDLIMITAREAANALYSISREGULATION_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    SpeedLimitAreaAnalysisRegulationServ_GetClientPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getClientPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SPEEDLIMITAREAANALYSISREGULATION_GETCLIENTPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SPEEDLIMITAREAANALYSISREGULATION_GETCLIENTPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    SpeedLimitAreaAnalysisRegulationServ_DatevehicleInfoGrouplocalalarmlimitspeedlimit({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        datevehicleInfoGrouplocalalarmlimitspeedlimit(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SPEEDLIMITAREAANALYSISREGULATION_DATEVEHICLEINFOGROUPLOCALALARMLIMITSPEEDLIMIT_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SPEEDLIMITAREAANALYSISREGULATION_DATEVEHICLEINFOGROUPLOCALALARMLIMITSPEEDLIMIT_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    SpeedLimitAreaAnalysisRegulationServ_DatelocalalarmlimitAndspeedlimit({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        datelocalalarmlimitAndspeedlimit(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SPEEDLIMITAREAANALYSISREGULATION_DATELOCALALARMLIMITANDSPEEDLIMIT_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SPEEDLIMITAREAANALYSISREGULATION_DATELOCALALARMLIMITANDSPEEDLIMIT_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_SpeedLimitAreaAnalysisRegulation_GetPageResult: state => {
      return state.state_SpeedLimitAreaAnalysisRegulation_GetPageResult;
    },
    get_SpeedLimitAreaAnalysisRegulation_GetDetailResult: state => {
      return state.state_SpeedLimitAreaAnalysisRegulation_GetDetailResult;
    },
    get_SpeedLimitAreaAnalysisRegulation_GetClientPageResult: state => {
      return state.state_SpeedLimitAreaAnalysisRegulation_GetClientPageResult;
    },
    get_SpeedLimitAreaAnalysisRegulation_DatevehicleInfoGrouplocalalarmlimitspeedlimitResult: state => {
      return state.state_SpeedLimitAreaAnalysisRegulation_DatevehicleInfoGrouplocalalarmlimitspeedlimitResult;
    },
    get_SpeedLimitAreaAnalysisRegulation_DatelocalalarmlimitAndspeedlimitResult: state => {
      return state.state_SpeedLimitAreaAnalysisRegulation_DatelocalalarmlimitAndspeedlimitResult;
    },
  }
}